import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Dashboard from "./pages/Dashboard";
import Income from "./pages/Income";
import Expenses from "./pages/Expenses";

import Projections from "./pages/Projections";
import FIRE from "./pages/FIRE";
import Collaboration from "./pages/Collaboration";
import Settings from "./pages/Settings";
import Assets from "./pages/Assets";
import PocketBaseTestPage from "./pages/PocketBaseTestPage";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <DataProvider>
          <Router>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/income" element={<Income />} />
                <Route path="/expenses" element={<Expenses />} />

                <Route path="/projections" element={<Projections />} />
                <Route path="/fire" element={<FIRE />} />
                <Route path="/collaboration" element={<Collaboration />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/assets" element={<Assets />} />
                <Route
                  path="/pocketbase-test"
                  element={<PocketBaseTestPage />}
                />
              </Routes>
            </Layout>
          </Router>
        </DataProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
